import React, { useCallback } from "react";
import RegisterMaterialExceptionModal from "./index";
import { useModal } from "@/hooks/modals/useModal";

// ==================== 主组件 ====================
/**
 * RegisterMaterialExceptionModal 适配器组件
 * 用于将 Modal 系统的 props 转换为 RegisterMaterialExceptionModal 组件所需的 props
 *
 * 根据是否有 taskId 来决定显示查看模式还是编辑模式：
 * - 有 taskId: 显示查看/审批模式（从工作台点击进入）
 * - 无 taskId: 显示新增/编辑模式（从列表页点击进入）
 */
const RegisterMaterialExceptionModalAdapter: React.FC = () => {
  const { open, props, closeModal } = useModal(
    "SUPPLIER_MATERIAL_ABNORMAL_REGISTER",
  );
  const {
    mode,
    viewStatus,
    recordId,
    taskId,
    onSuccess,
    flowStatus,
    isReadOnly,
    businessStatus,
  } = props || {};

  // 处理关闭
  const handleClose = useCallback(() => {
    closeModal();
    // 关闭后调用成功回调以刷新列表
    if (onSuccess) {
      onSuccess();
    }
  }, [closeModal, onSuccess]);

  // 判断是否为只读模式
  const isReadOnlyMode = viewStatus === true || isReadOnly;

  console.log("🔍 RegisterMaterialExceptionModalAdapter - 参数:", {
    mode,
    taskId,
    recordId,
    viewStatus,
    flowStatus,
    businessStatus,
    isReadOnlyMode,
  });

  return (
    <RegisterMaterialExceptionModal
      visible={open}
      editId={recordId}
      onClose={handleClose}
      readOnly={isReadOnlyMode}
      businessStatus={businessStatus}
    />
  );
};

export default RegisterMaterialExceptionModalAdapter;
